import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["frame", "loading", "error", "summary"]

  loading(event) {
    if (event && event.target !== this.frameTarget) return

    if (this.hasErrorTarget) this.errorTarget.hidden = true
    if (this.hasLoadingTarget) this.loadingTarget.hidden = false
  }

  checkResponse(event) {
    if (event.target !== this.frameTarget) return

    const response = event.detail.fetchResponse
    if (!response.succeeded || response.redirected) this.error(event)
  }

  error(event) {
    if (event.target !== this.frameTarget) return

    event.preventDefault()
    if (this.hasLoadingTarget) this.loadingTarget.hidden = true
    if (this.hasErrorTarget) this.errorTarget.hidden = false
  }

  retry() {
    if (this.hasSummaryTarget && this.hasErrorTarget && this.errorTarget.contains(document.activeElement)) {
      this.summaryTarget.focus()
    }
    this.loading()
    if (this.frameTarget.loading === "lazy") {
      this.frameTarget.removeAttribute("complete")
      this.frameTarget.loading = "eager"
    } else {
      this.frameTarget.reload()
    }
  }
}
